@solidale.controller 'LocIndexCtrl', ['$rootScope', '$scope', '$state', '$stateParams', 'Location', 'uiGmapGoogleMapApi', 'uiGmapIsReady', '$q', ($rootScope, $scope, $state, $stateParams, Location, uiGmapGoogleMapApi, uiGmapIsReady, $q) ->

	# ===============
	# Get Locations
	# ================
	# Locations			
	$getLocations = () ->
		defer = $q.defer()

		Location.get().then (resp) ->
			
			$scope.locations = resp.data

			defer.resolve $scope.locations
			defer.promise
		

	# Markers		
	$createMarker = () ->
		defer = $q.defer()

		$scope.locationMap.markers = []

		for d, i in $scope.locations
			$marker = 
				id: i
				coords:
					latitude: d.lat
					longitude: d.lng
				options:
					zIndex: 10
					icon: '/image/icon-home.png'

				click: (intance, event, marker)->
					$window_event(marker)	


			$scope.locationMap.markers.push $marker

		defer.resolve $scope.locationMap.markers
		defer.promise


	# Bounds	
	$fitBound = () ->
		
		bounds = new google.maps.LatLngBounds()
		for marker in $scope.locationMap.markers
			bounds.extend(new google.maps.LatLng(marker.coords.latitude, marker.coords.longitude))

		$scope.locationMap.control.getGMap().fitBounds(bounds)


	# Window
	$window_event = (marker) ->
		$scope.window.coords.latitude = marker.coords.latitude
		$scope.window.coords.longitude = marker.coords.longitude
		$scope.window.show = true
		$scope.window.options.visible = true
		$scope.window.templateParameter = 
			loc: $scope.locations[marker.idKey] 

	# ================
	# Gmaps 
	# ==================
	uiGmapGoogleMapApi.then (maps) ->
		$scope.locationMap = 
			center:
				latitude: 35.0060799
				longitude: 135.7259288
			zoom: 14
			options:
				scrollwheel: false
				mapTypeControl: false
			control: {}

		$scope.window = 
			coords:
				latitude: 35.0361254
				longitude: 135.78123
			show: false
			templateUrl: 'views/gmapwindow.html'
			templateParameter: ''
			close: ()->
				$scope.window.show = false
			options:
				visible: false


		uiGmapIsReady.promise().then () ->	

			$getLocations().then (resp1) ->
				$createMarker().then (resp2)->
					$fitBound()


	$scope.showInMap = (ind)->
		$scope.locationMap.markers[ind].options.icon = '/image/icon-home-hover.png'


	$scope.hideInMap = (ind)->
		$scope.locationMap.markers[ind].options.icon = '/image/icon-home.png'	

]